import { Component } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CalendarEventForSelectEventFragment } from "graphql.generated";
import { SharedModule } from "primeng/api";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";
import { ResponsiveHelperService } from "src/app/services/responsive-helper.service";

import { WorkOrdersActions } from '../job-state/workorders-state/workorders.actions';
import { workOrdersSelectors } from "../job-state/workorders-state/workorders.selectors";


@Component({
    selector: 'app-event-select-v2',
    standalone: true,
    imports: [SharedModule, FreyaCommonModule],
    templateUrl: './event-select-v2.component.html',
    styleUrl: './event-select-v2.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: EventSelectV2Component
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: EventSelectV2Component,
        }
    ]
})

export class EventSelectV2Component {
    placeholder = 'Select Events';

    // FORM CONTROL VARIABLES
    selectedEvents: CalendarEventForSelectEventFragment[] = [];
    touched = false;
    disabled = false;

    constructor(
        private store: Store,
        public responsiveHelper: ResponsiveHelperService,
    ) { }

    jobEvents$ = this.store.select(workOrdersSelectors.selectAllActiveJobEventsIncludingUnsaved);
    eventSuggestions$ = this.store.select(workOrdersSelectors.selectSuggestedEventsForAddChargesAndDiscounts);
    selectedEvents$ = this.store.select(workOrdersSelectors.selectSelectedEventsForAddChargesAndDiscounts);

    selectEvent(events): void {
        const selectedEventsIds = events?.map(e => e?.id);
        this.store.dispatch(WorkOrdersActions.eventSelectedFromSuggestions({ ids: selectedEventsIds }));
    }

    //remove after refactoring of components where app-event-select-v2 is used
    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }

    writeValue(events) {

    }

    registerOnChange(onChange) {

    }

    registerOnTouched(onTouched) {

    }
}
